import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { formatPhoneNumber } from '../NumberFormatter';

const SizePreview = ({ formData, onOverflow }) => {
  const {
    gender = '',
    hline1 = '',
    hline2 = '',
    hline3 = '',
    hline1fs = '6pt',
    hlinebg = 'Normal',
    content = '',
    contentbg = 'Normal',
    contentfs = '8pt',
    whatsapp = '',
    mobile = '',
    email = '',
    contactbg = 'Normal',
    agency = '',
    size = '', 
    crn = ''
  } = formData;

  const contentRef = useRef(null);
  // eslint-disable-next-line
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      const el = contentRef.current;
      // console.log("el useeffect ref:", el)
      // exclude agency height
      const agencyEl = el.querySelector('#agencyText');
      const agencyHeight = agencyEl ? agencyEl.offsetHeight : 0;
  
      const overflowing =
        el.scrollHeight - agencyHeight > el.clientHeight ||
        el.scrollWidth > el.clientWidth;
  
      setIsOverflowing(overflowing);
      if (onOverflow) {
        onOverflow(overflowing ? "Content too long: does not fit within card." : null);
      }
    }
    // eslint-disable-next-line
  }, []);
  

  // Parse size
  const defaultHeight = 10;   // default height (cm)
  const defaultWidth = 3.8;   // default width (cm)

  let cardWidthCm = defaultWidth;
  let cardHeightCm = defaultHeight;

  // if DB sends only a number (height)
  if (size && !isNaN(Number(size))) {
    cardHeightCm = Number(size);
  }
  const POINTS_PER_CM = 28.346;
  const cardStyle = {
    width: `${cardWidthCm*POINTS_PER_CM}pt`,   // always default width
    height: `${cardHeightCm*POINTS_PER_CM}pt`, // height from DB or default
    border: '0.25pt solid black',
    padding: 0,
    marginBottom: '1pt',
    backgroundColor: '#ffffff',
    position: 'relative',
  };



  console.log("w&h:", cardStyle.width, cardStyle.height)

  const getDirection = (text) => {
    const rtlChars = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return rtlChars.test(text) ? 'rtl' : 'ltr';
  };

  const headingThemeClass =
    hlinebg === 'Dark'
      ? 'bg-gray-900 font-bold text-white px-1'
      : 'bg-white text-gray-900 px-1';

  const contentThemeClass =
    contentbg === 'Dark'
      ? 'bg-gray-900 text-white px-1'
      : 'bg-white text-gray-900 px-1';

  const contactThemeClass =
    contactbg === 'Dark'
      ? 'bg-gray-900 text-white px-1'
      : 'bg-white text-gray-900 px-1';

  // Process heading lines
  const headingLines = [hline1, hline2, hline3]
    .map(line => (line || '').trim())
    .filter(Boolean);

    const genderTrimmed = (gender || '').trim();
  const genderLower = genderTrimmed.toLowerCase();

  const hasBoyOrGirl = headingLines.some(line => {
    const lowerLine = line.toLowerCase();
    return lowerLine.includes('boy') || lowerLine.includes('girl') || lowerLine.includes(genderLower);
  });

  let combinedHeading;
  if (hasBoyOrGirl) {
    combinedHeading = headingLines.join('\n');
  } else {
    const hlinesCombined = headingLines.join('\n');
    const genderTrimmed = gender.trim();
    combinedHeading = hlinesCombined && genderTrimmed
      ? `${hlinesCombined} ${genderTrimmed}`
      : hlinesCombined || genderTrimmed;
  }

  const headingElement = combinedHeading ? (
    <p
      className="text-center m-0"
      style={{ fontSize: hline1fs, whiteSpace: 'pre-line' }}
      dir={getDirection(combinedHeading)}
    >
      {combinedHeading}
    </p>
  ) : null;

  function formatContact(value, contactClass, textClass) {
    if (!value) return null;

    const match = value.match(/^(.*?)(\+?\d{8,15})(.*)$/);
    if (match) {
      const [, prefix, numberPart, suffix] = match;
      return (
        <p>
          {prefix && <span className={textClass}>{prefix}</span>}
          {numberPart && <span className={contactClass}>{numberPart}</span>}
          {suffix && <span className={textClass}>{suffix}</span>}
        </p>
      );
    }
    return <p className={textClass}>{value}</p>;
  }
  return (
      <div style={cardStyle} ref={contentRef}>
        {headingElement && <div className={`leading-[1.1] ${headingThemeClass}`}>{headingElement}</div>}

        {content && (
          <div className={`${contentThemeClass}`} dir={getDirection(content)}>
            <div className="text-justify leading-[1.2] mt-0.5 break-words"
              style={{ fontSize: contentfs }}>
              {content}
            </div>
          </div>
        )}

        {(whatsapp || mobile || email) && (
          <div className={`mb-0 leading-none ${contactThemeClass}`}>
            {whatsapp && formatContact(
              whatsapp,
              "font-extrabold text-[14px]",   // contactfs (number styling)
              "text-[8px] font-extrabold"       // headline1fs (text styling)
            )}
            {mobile && formatContact(
              mobile,
              "font-extrabold text-[14px]",   // contactfs (number styling)
              "text-[8px] font-extrabold"       // headline1fs (text styling)
            )}
            {email && (<p className="text-xs break-all">{email}</p>)}
          </div>
        )}


      {/* 👇 Agency fixed inside card */}
      {agency && (
        <p
        id="agencyText"
          className="text-gray-900 bg-white text-[9px] text-end"
          style={{
            position: 'absolute',
            bottom: -9,
            right: '4px',
            backgroundColor: '#ffffff',
            padding: '0 2px'
          }}
        >
          {agency}/{String(crn).slice(-4)}
        </p>
      )}
    </div>
  );
};


SizePreview.propTypes = {
  formData: PropTypes.object.isRequired,
  onOverflow: PropTypes.func
};

export default SizePreview;
